// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimesheetVM  {
    _originalTypeClassName = "Loom.BO.TimesheetVM";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimesheetVM.translate = translateService;
}
this.TimesheetEntries = [];
this.Attachments = [];
this.Id = null;
this.Month = null;
this.Notes = null;
this.DateSubmitted = null;
this.DateApproved = null;
this.TotalHoursReported = null;
this.WPs = null;
this.Status = null;
this.Approver = null;
this.SubmittedBy = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Month:any;
Notes:any;
DateSubmitted:any;
DateApproved:any;
TotalHoursReported:any;
WPs:any;
Status:any;
Approver:any;
SubmittedBy:any;
TimesheetEntries:any;
Employee:any;
Attachments:any;
static setTimesheetEntries = ($this, items) => {
                if (items == null) items = [];
                if ($this.TimesheetEntries == null) $this.TimesheetEntries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TimesheetEntries.length > 0) {
                    Domain.TimesheetVM.removeTimesheetEntries($this, $this.TimesheetEntries[0]);
                }

                Domain.TimesheetVM.addManyTimesheetEntries($this, copyItems);
            }
static addManyTimesheetEntries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TimesheetVM.addTimesheetEntries($this, items[i]);
                }
            }
static addTimesheetEntries = ($this, item) => {
                if ($this.TimesheetEntries == null) $this.TimesheetEntries = [];
                if (item == null || $this.TimesheetEntries.indexOf(item) > -1) return;
                $this.TimesheetEntries.push(item);
}
static addRangeTimesheetEntries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TimesheetVM.addTimesheetEntries($this, item));
            }
static removeTimesheetEntries = ($this, item) => {
                if ($this == null || $this.TimesheetEntries == null || $this.TimesheetEntries.indexOf(item) === -1) return;
                var _index = $this.TimesheetEntries.indexOf(item);
                $this.TimesheetEntries.splice(_index, 1);
}
static clearTimesheetEntries = ($this) => { $this.TimesheetEntries = null; }
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setAttachments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attachments == null) $this.Attachments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attachments.length > 0) {
                    Domain.TimesheetVM.removeAttachments($this, $this.Attachments[0]);
                }

                Domain.TimesheetVM.addManyAttachments($this, copyItems);
            }
static addManyAttachments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TimesheetVM.addAttachments($this, items[i]);
                }
            }
static addAttachments = ($this, item) => {
                if ($this.Attachments == null) $this.Attachments = [];
                if (item == null || $this.Attachments.indexOf(item) > -1) return;
                $this.Attachments.push(item);
}
static addRangeAttachments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TimesheetVM.addAttachments($this, item));
            }
static removeAttachments = ($this, item) => {
                if ($this == null || $this.Attachments == null || $this.Attachments.indexOf(item) === -1) return;
                var _index = $this.Attachments.indexOf(item);
                $this.Attachments.splice(_index, 1);
}
static clearAttachments = ($this) => { $this.Attachments = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}